// Static meta tags for Group Chat Heroes
export const getMetaTags = () => {
  return {
    title: 'Group Chat Heroes | Free Game Creator for Friend Groups',
    description: 'Create custom games for your friend group! Quiz games, Snake, geography challenges, and more. Share instantly and compete on leaderboards - no downloads required!',
    siteName: 'Group Chat Heroes',
    domain: 'https://groupchatheroes.com',
    image: 'https://groupchatheroes.com/twitter-gch.png',
    keywords: 'friend group games, custom games, group chat games, quiz creator, party games, mobile games, social games, friend challenges',
    author: 'Group Chat Heroes',
    twitterSite: '@groupchatheroes',
    themeColor: '#F1C40F' // Retro arcade yellow
  };
};

// Initialize SEO on page load
export const initializeDynamicSEO = () => {
  // Set the favicon
  const favicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
  if (favicon) {
    favicon.href = '/favicon.ico';
  }

  // Set the document title
  document.title = getMetaTags().title;
}; 